import { render, staticRenderFns } from "./host.vue?vue&type=template&id=be1ccddc&scoped=true"
import script from "./host.vue?vue&type=script&lang=ts"
export * from "./host.vue?vue&type=script&lang=ts"
import style0 from "./host.vue?vue&type=style&index=0&id=be1ccddc&prod&lang=scss"
import style1 from "./host.vue?vue&type=style&index=1&id=be1ccddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1ccddc",
  null
  
)

export default component.exports